export default __webpack_public_path__ + "static/media/search.93aa7c8e.svg";